import { render, staticRenderFns } from "./ServeCountForLink.vue?vue&type=template&id=6ce22434&scoped=true&"
import script from "./ServeCountForLink.vue?vue&type=script&lang=js&"
export * from "./ServeCountForLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce22434",
  null
  
)

export default component.exports